module.exports = __webpack_public_path__ + "static/img/banner_product2.0e567eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comm/banner_product2.jpg
// module id = yAcI
// module chunks = 0